<template>
  <b-modal
    ref="modal"
    id="send-message-modal"
    title="Send a Message"
  >
    <form-component>
      <form novalidate="novalidate">

        <div v-if="adminMode">
          <!--
            select one or all schools
            select all or just counselors or just students
          -->

          <input-type-ahead
            :list="colleges"
            :value="college"
            :searchchange="getColleges"
            :selected-value="selectedCollege"
            placeholder="Search for a College..."
            label="Send to College"
            option-value="id"
            option-text="display_name"
          />

          <label class="replacement-label">Recipient Type</label>
          <div class="form-row hide-label">
            <div class="col-12">
              <input-select
                id="recipientType"
                v-model="recipientType"
                name="recipientType"
                label="Recipient Type"
                type="select"
                placeholder="Recipient Type"
                :options="recipientTypeOptions"
              />
            </div>
          </div>

        </div>




        <input-text
          id="subject"
          v-model="subject"
          v-validate="'required'"
          name="subject"
          data-vv-name="subject"
          data-vv-as="subject"
          label="Your Subject"
          type="text"
          required
          :error="errors.first('subject')"
        />

        <input-text-area
          id="message"
          v-model="message"
          v-validate="'required'"
          name="message"
          data-vv-name="message"
          data-vv-as="message"
          label="Your Message"
          type="text"
          required
          :error="errors.first('message')"
        />
      </form>
    </form-component>

    <template
      slot="modal-footer"
      slot-scope="{ ok, cancel }"
    >
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Send</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputSelect from '@/components/inputs/InputSelect.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';

export default {
  name: 'SendMessageModal',
  components: {
    FormComponent,
    InputText,
    InputSelect,
    InputTextArea,
    InputTypeAhead,
  },
  data() {
    return {
      user_id: null,
      replyToMessage: null,

      userClient: new UserClient(this.$http),
      adminClient: new AdminClient(this.$http),
      saving: false,
      subject: '',
      message: '',
      adminMode: false,

      // typeahead
      colleges: [], // { id, name, state_code }
      _getCollegesTimeout: null,
      college: null,

      recipientType: '',
      recipientTypeOptions: [{ id: '', display_label: 'All Students & Counselors' }, {id: 'students', display_label: 'All Students' }, { id: 'counselors', display_label: 'All Counselors' }],
    };
  },
  methods: {
    adminShow(filters) {
      this.user_id = null;
      this.replyToMessage = null;
      this.message = '';
      this.subject = '';
      this.adminMode = true;

      if (filters && filters.school) {
        this.colleges = [filters.school];
        this.college = filters.school.id;
      }

      this.$refs.modal.show();
    },
    show(user_id, replyToMessage) {
      this.adminMode = false;
      this.user_id = user_id;
      this.replyToMessage = replyToMessage || null;
      this.message = '';
      this.subject = '';

      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },

    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();
          this.saving = true;

          if (this.college) {
            // send message to specific college
            this.adminClient.sendMessage(this.college, this.recipientType, this.subject, this.message).then(res => {
              this.saving = false;
              this.hide();
              this.$store.commit('setGlobalAlert', {
                msg: 'Message Sent!',
              });
            }).catch(ex => {
              this.$store.commit('setGlobalAlert', {
                msg: 'Failed to send message. Please try again!', error: true,
              });
              this.saving = false;
            });

          } else {

            if (this.user_id) {
              // from dashboard
              this.userClient.sendMessage(this.user_id, this.subject, this.message).then(res => {
                this.saving = false;
                this.hide();
                this.$store.commit('setGlobalAlert', {
                  msg: 'Message Sent!',
                });
              }).catch(ex => {
                this.$store.commit('setGlobalAlert', {
                  msg: 'Failed to send message. Please try again!', error: true,
                });
                this.saving = false;
              });
            } else if (this.replyToMessage) {
              // from inbox
              const otherUserId = this.replyToMessage.getOtherUser(this.$store.getters.currentUser.id);

              this.userClient.sendMessage(otherUserId, this.subject, this.message, this.replyToMessage.message_thread).then(res => {
                this.saving = false;
                this.hide();
                this.$store.commit('setGlobalAlert', {
                  msg: 'Message Sent!',
                });
              }).catch(ex => {
                this.$store.commit('setGlobalAlert', {
                  msg: 'Failed to send message. Please try again!', error: true,
                });
                this.saving = false;
              });
            }
          }
        }
      });
    },




    // admin type-ahead
    getColleges(query, done) {
      if (this.college && !query) {
        // we just selected one, do not empty the results
        return;
      }

      if (this._getCollegesTimeout) {
        clearTimeout(this._getCollegesTimeout);
        this._getCollegesTimeout = null;
      }

      this._getCollegesTimeout = setTimeout(() => {
        this.userClient.getCollegeList(query)
        // this.adminClient.getSchoolsList({
        //   search: query,
        // })
        .then((colleges) => {
          this.college = null;
          this.colleges = colleges.results || [];
        }).catch(() => {
          this.college = null;
          this.colleges = [];
        });
      }, 300);
    },
    selectedCollege(v) {
      this.college = v;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
